<template>
  <div class="content">
    <div style="height: 70px;">
      <HomeHeader :forOrder="true"></HomeHeader>
    </div>

    <div class="confirm_order_box">
      <div></div>
      <div style="margin-bottom: 20px">
        <p style="font-family:'苹方';font-size: 14px;margin: 30px 0;">
          <span style="color:#1e50f0">订单管理</span>
          /
          <span style="color:#1e50f0">订单详情</span>
          / 酒店确认单({{ orderDetailData.outerOrderId }})
        </p>

        <div class="config_box">
          <div>
            <div style="margin-bottom: 10px">
              <el-checkbox v-model="showCozyTimeInfo">是否显示科坦信息</el-checkbox>
            </div>
            <div>
              <el-radio-group v-model="lang">
                <el-radio :label="1">中英文版</el-radio>
                <el-radio :label="2">纯英文版</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div>
            <b2b-button @click="downLoadPdf"
                        style="width: 80px;height: 30px;line-height: 30px;border-radius: 50px">
              下载pdf
            </b2b-button>
          </div>
        </div>

        <div id="hotelConfirmOrder">
          <div class="header">
            <div style="display: flex;column-gap: 15px;align-items: center" v-if="showCozyTimeInfo">
              <div>
                <img src="@/assets/newWebSiteImg/common/logo_mini.png" style="width: 220px;cursor: pointer;">
              </div>
              <div>
                <p style="margin-bottom: 8px">
                  <span class="title cn">电话</span>
                  <span class="title">Tel:</span>
                  <span>0755-23502423</span>
                </p>
                <p>
                  <span class="title cn">邮箱</span>
                  <span class="title">Email:</span>
                  <span>customerservice@cozy-time.com</span>
                </p>
              </div>
            </div>
            <div>
              <p style="font-size: 16px;color: #148cf5;margin-bottom: 8px" class="cn">酒店确认单</p>
              <p style="font-size: 16px;color: #148cf5;">Hotel confirmation</p>
            </div>
          </div>

          <div class="order_info">
            <div class="order_info_item">
              <span class="title cn">订单号</span>
              <span class="title">Order Number</span>
              <p class="info_detail">{{ orderDetailData.channelOrderNum }}</p>
            </div>
            <div class="order_info_item">
              <span class="title cn">确认号</span>
              <span class="title">Confirmation Number</span>
              <p class="info_detail">{{ orderDetailData.hotelConfirmationNumber }}</p>
            </div>
            <div class="order_info_item">
              <span class="title cn">入住日期</span>
              <span class="title">Check In</span>
              <p class="info_detail">{{ orderDetailData.checkIn }}</p>
            </div>
            <div class="order_info_item">
              <span class="title cn">离店日期</span>
              <span class="title">Check Out</span>
              <p class="info_detail">{{ orderDetailData.checkOut }}</p>
            </div>
            <div class="order_info_item">
              <span class="title cn">房间数</span>
              <span class="title">Unit</span>
              <p class="info_detail">{{ orderDetailData.roomCount }}</p>
            </div>
            <div class="order_info_item">
              <span class="title cn">入住人</span>
              <span class="title">Guest</span>
              <p class="info_detail">{{ orderDetailData.guestName }}</p>
            </div>
          </div>

          <div class="hotel_info_box">
            <div class="info_item_box">
              <div class="item">
                <span class="title cn">酒店名</span>
                <span class="title">Hotel Name</span>
                <p class="info_detail">
                  <span class="cn">{{ hotelInfo.hotelNameCn }}</span>
                  <span>{{ hotelInfo.hotelNameEn }}</span>
                </p>
              </div>
              <div class="item">
                <span class="title cn">地址</span>
                <span class="title">Address</span>
                <div class="info_detail">
                  <span class="cn">{{ hotelInfo.addressCn === hotelInfo.addressEn ? '' : hotelInfo.addressCn }}</span>
                  <span>{{ hotelInfo.addressEn === hotelInfo.addressCn ? hotelInfo.addressEn : '' }}</span>

                  <p>
                    <span class="cn">{{ hotelInfo.cityNameCn }}</span>
                    <span>{{ hotelInfo.cityNameEn }}</span>

                    <span class="cn">{{ hotelInfo.countryNameCn }}</span>
                    <span>{{ hotelInfo.countryNameEn }}</span>
                  </p>
                </div>
              </div>
              <div class="item">
                <span class="title cn">电话</span>
                <span class="title">Contact Phone</span>
                <p class="info_detail">{{ hotelInfo.phone }}</p>
              </div>
            </div>
            <div class="info_item_box">
              <div class="item">
                <span class="title cn">房型</span>
                <span class="title">Room Type</span>
                <div class="info_detail">
                  <p class="cn">{{ hotelInfo.roomNameCn }}</p>
                  <p>{{ hotelInfo.roomNameEn }}</p>
                </div>
              </div>
              <div class="item">
                <span class="title cn">床型</span>
                <span class="title">Bed Type</span>
                <p class="info_detail">
                  <span class="cn">{{ hotelInfo.bedTypeCn }}</span>
                  <span>{{ hotelInfo.bedTypeEn }}</span>
                </p>
              </div>
              <div class="item">
                <span class="title cn">人数</span>
                <span class="title">Number</span>
                <p class="info_detail">
                  <span class="cn">{{ getOccupancy() }}人</span>
                  <span>{{ getOccupancy() }}adult</span>
                </p>
              </div>
              <div class="item">
                <span class="title cn">餐食</span>
                <span class="title">Dinning</span>
                <p class="info_detail" v-if="orderDetailData.breakfastDesc">
                  <span class="cn">{{ orderDetailData.breakfastDesc }}</span>
                  <span>{{ orderDetailData.breakfastDesc.replace('早', 'breakfast').replace('无', 'no ').replace('单', '1').replace('双', '2') }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="hotel_comments">
            <span class="title cn" style="color: #7f7f7f;font-size: 15px">酒店提示</span>
            <span class="title" style="color: #7f7f7f;font-size: 15px">Hotel Comments</span>
            <div class="comments">
              <p>
                <span class="cn">1.重要提示：办理入住时，请出示有效身份证件，且证件姓名需与客人代表的姓名一致。</span>
                <span v-show="lang === 2">1. Important: When checking in, please present a valid ID and the name on the ID must be the same as the name of the guest representative.</span>
              </p>
              <p>
                <span class="cn">2.所有特殊申请需于酒店前台办理入住手续时以酒店最终确认为准</span>
                <span v-show="lang === 2">2. All special requests are subject to the hotel's final confirmation upon check-in at the front desk</span>
              </p>
              <p>
                <span class="cn">3.酒店将在您抵达当天预留您所预订的客房，如果您未能在当天抵达酒店，您预订的房间可能被收回，具体请参看在预订过程的取消政策。</span>
                <span v-show="lang === 2">3. The hotel will reserve your reserved room on the day of your arrival, if you fail to arrive at the hotel on the same day, your reservation may be reclaimed, please refer to the cancellation policy during the booking process.</span>
              </p>
              <p>
                <span class="cn">4.此次预订的总费用不包含冰箱内的食物/饮料，电话费用以及干洗服务等，酒店将直接向您收取费用。</span>
                <span v-show="lang === 2">4. The total cost of this booking does not include food/drinks in the refrigerator, telephone and dry cleaning services, etc., and you will be charged directly by the hotel.</span>
              </p>
              <p>
                <span class="cn">5.对于房费中已包含早餐的预订，部分酒店可能会对随行儿童收取额外的早餐费，请直接向酒店付费，如有疑问，请在入住时与酒店确认。</span>
                <span v-show="lang === 2">5. For reservations where breakfast is included in the room rate, some hotels may charge an additional breakfast fee for accompanying children, please pay directly to the hotel, if you have any questions, please confirm with the hotel at check-in.</span>
              </p>
            </div>
          </div>

        </div>

      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import HomeHeader from '../../booking/components/HomeHeader.vue'

export default {
  name: 'HotelConfirmOrder',
  components: {HomeHeader},
  data () {
    return {
      orderDetailData: {},
      showCozyTimeInfo: true,
      /**
       * 1：中英文版、2：纯英文版
       */
      lang: 1,
      hotelInfo: {}
    }
  },
  mounted () {
    if (this.$route.query.params) {
      let info = window.atob(this.$route.query.params)
      this.orderDetailData = JSON.parse(decodeURIComponent(info))
      this.searchHotel()
    } else {
      this.$router.push('/NewHome/HomeSearch')
    }
  },
  watch: {
    lang (val) {
      let el = this.$el.querySelectorAll('.cn')
      el.forEach(item => {
        item.style.display = val === 1 ? '' : 'none'
      })
    }
  },
  methods: {
    async searchHotel () {
      let req = {
        orderId: this.orderDetailData.orderId
      }
      const {data: result} = await this.$http.get('/b2b/searchSHotelRoom', {params: req})
      if (result.code !== 200) return
      this.hotelInfo = result.data
      if (this.hotelInfo.bedTypeDescCn) {
        this.hotelInfo.bedTypeCn = this.hotelInfo.bedTypeDescCn
        this.hotelInfo.bedTypeEn = this.parseBedTypes(this.hotelInfo.bedTypeDescCn)
      } else {
        this.hotelInfo.bedTypeCn = '未知'
        this.hotelInfo.bedTypeEn = 'unknown'
      }
    },
    parseBedTypes (chineseDescription) {
      chineseDescription = chineseDescription.replace("(").replace(")")
      const bedMapping = [
        { "bedNameCn": "大床", "bedNameEn": "Queen bed" },
        { "bedNameCn": "特大床", "bedNameEn": "King bed" },
        { "bedNameCn": "双人床", "bedNameEn": "Double bed" },
        { "bedNameCn": "圆床", "bedNameEn": "Round bed" },
        { "bedNameCn": "水床", "bedNameEn": "Water bed" },
        { "bedNameCn": "榻榻米", "bedNameEn": "tatami" },
        { "bedNameCn": "炕", "bedNameEn": "ondol" },
        { "bedNameCn": "沙发床", "bedNameEn": "sofa bed" },
        { "bedNameCn": "单人床", "bedNameEn": "single bed" },
        { "bedNameCn": "上下铺", "bedNameEn": "bunk bed" },
        { "bedNameCn": "日式床垫", "bedNameEn": "futon" },
        { "bedNameCn": "床位", "bedNameEn": "bed" },
        { "bedNameCn": "太空舱", "bedNameEn": "Space Capsule" },
        { "bedNameCn": "胶囊床", "bedNameEn": "Capsule bed" },
        { "bedNameCn": "其他床", "bedNameEn": "other" }
      ]
      const cnToEnMap = new Map()
      bedMapping.forEach(item => {
        cnToEnMap.set(item.bedNameCn,  item.bedNameEn)
      });
      const segments = chineseDescription.split(/和|或/)
      const results = []
      for (const segment of segments) {
        const trimmedSegment = segment.trim()
        if (!trimmedSegment) continue
        // 从片段中提取数量和床型
        const match = trimmedSegment.match(/(\d+)张([^\s和或]+)/)
        if (match) {
          const quantity = parseInt(match[1])
          const bedTypeCn = match[2].trim()
          if (cnToEnMap.has(bedTypeCn)) {
            let bedTypeEn = cnToEnMap.get(bedTypeCn);
            if (quantity > 1) {
              bedTypeEn = bedTypeEn.replace(/\bbed\b/g,  'beds')
            }
            results.push(`${quantity}  ${bedTypeEn}`)
          } else {
            console.warn(` 未找到床型 "${bedTypeCn}" 的英文映射`)
            results.push(trimmedSegment)
          }
        } else {
          console.warn(` 无法解析片段: "${trimmedSegment}"`)
          results.push(trimmedSegment)
        }
      }
      let resultString = results[0] || ''
      for (let i = 1; i < results.length; i++) {
        const separator = this.findOriginalSeparator(chineseDescription, i - 1)
        resultString += ` ${separator} ${results[i]}`
      }
      return resultString.replace(/  +/g, ' ')
    },
    findOriginalSeparator(description, separatorIndex) {
      const matches = [...description.matchAll(/ 和|或/g)]
      if (matches[separatorIndex]) {
        const originalSeparator = matches[separatorIndex][0]
        return originalSeparator === '和' ? 'and' : 'or'
      }
      return 'and'
    },
    downLoadPdf () {
      this.$nextTick(() => {
        this.htmlToPdf('hotelConfirmOrder', `酒店确认单_${this.orderDetailData.channelOrderNum}`)
      })
    },
    getOccupancy () {
      if (this.orderDetailData.occupancy) {
        try {
          return JSON.parse(this.orderDetailData.occupancy)[0].adultCount
        } catch (e) {
        }
      }
      return this.orderDetailData.guestName ? this.orderDetailData.guestName.split("|").length : 0
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background-color: #f5f7fa;
}

.confirm_order_box {
  display: grid;
  grid-template-columns: auto 850px auto;
  min-height: calc(100vh - 70px);
  font-size: 13px;

  .config_box {
    background-color: #fff;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 25px;
    margin-bottom: 25px;
  }

  #hotelConfirmOrder {
    font-family: '苹方';
    background-color: #fff;
    padding: 20px;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 3px solid #7f7f7f;
      padding: 10px 0 25px 0;
      margin-bottom: 25px;
    }

    .title {
      color: #7f7f7f;
      margin-right: 2px;
    }

    .info_detail {
      margin-top: 15px;
      line-height: 20px;
    }

    .order_info {
      border: 1px solid #ccdceb;
      padding: 25px 20px;
      display: flex;
      column-gap: 25px;
      row-gap: 25px;
      flex-wrap: wrap;
      margin-bottom: 25px;

      .order_info_item {
        width: max-content;
      }
    }

    .hotel_info_box {
      display: flex;
      justify-content: space-between;

      .info_item_box {
        width: 49%;
        padding: 20px;
        border: 1px solid #ccdceb;
        margin-bottom: 25px;

        .item:not(:last-child) {
          margin-bottom: 25px;
        }
      }
    }

    .hotel_comments {
      .comments {
        padding-left: 20px;
        margin-top: 15px;
        font-size: 12px;

        p {
          margin-bottom: 10px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/HotelConfirmOrder.vue